import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { appendStripes, updateStripes } from './stripes';
gsap.registerPlugin(ScrollTrigger);

const state = {
   headlines: {},
};

export const buildNavigation = () => {
   if (!document.querySelector('#js-buildNavigation')) return false;
   const cards = document.querySelectorAll('.box');
   if (!cards) return false;

   //headlines deco
   cards.forEach((card) => {
      const id = card.getAttribute('id');
      const headline = card.querySelector('.card__headline');
      state.headlines[id] = appendStripes(headline, 100, true);
   });

   //build sidebar
   const sidebar = document.createElement('div');
   sidebar.id = 'sidebar';
   const list = document.createElement('ul');
   cards.forEach((card, index) => {
      const id = card.getAttribute('id');
      const svg = card.querySelector('.card__icon').innerHTML;
      const label = card.querySelector('.card__headline h2').innerHTML;
      list.innerHTML += `
         <li class="nav__item" id="nav-item-${id}">
            <a href="#${id}">
            ${svg}
            <span>${label}</span>
            </a>
         </li>
      `;
      trackCard(card);
   });
   sidebar.appendChild(list);
   document.querySelector('#wrapper').appendChild(sidebar);

   //track sidebar
   handleNavigationView(document.documentElement.scrollTop >= window.innerHeight / 2);
   trackNavigationWrapper();
};

const trackNavigationWrapper = () => {
   ScrollTrigger.create({
      trigger: '.header',
      start: 'top top',
      endTrigger: '.header',
      end: 'bottom center',
      onToggle: (self) => {
         console.log('self', self);
         const show = self.progress > 0 && !self.isActive;
         console.log(self.progress, !self.isActive, show);
         handleNavigationView(show);
      },
   });
};

const trackCard = (card) => {
   const box = document.querySelector('.box');
   const iconHeight = document.querySelector('.card__icon').offsetHeight;
   const distanceFromPadding = Number(
      window.getComputedStyle(box, null).getPropertyValue('padding-top').replace('px', '')
   );
   ScrollTrigger.create({
      trigger: card,
      start: `top ${window.innerHeight / 2 - (distanceFromPadding - iconHeight / 2)}px`,
      endTrigger: card,
      end: 'bottom center',
      onToggle: (self) => {
         activateCard(card);
         const id = card.getAttribute('id');
         updateStripes(state.headlines[id], 0.02);
      },
   });
};

const activateCard = (card) => {
   resetNavItems();
   card.classList.add('active');
   const id = card.getAttribute('id');
   const target = document.querySelector(`#nav-item-${id}`);
   if (target) target.classList.add('active');
};

const resetNavItems = () => {
   document.querySelectorAll('.nav__item').forEach((item) => {
      item.classList.remove('active');
   });
};

const handleNavigationView = (show) => {
   console.log('show sidebar', show);
   if (show) document.querySelector('#sidebar').classList.add('active');
   if (!show) document.querySelector('#sidebar').classList.remove('active');
};
